import { AxiosError } from 'axios';
import { useToast } from '@quinyx/ui';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { editConfigs, getConfigs } from '../../api/endpoints/config';
import { IConfig, IConfigPayload } from '../../api/interfaces/customer';

export const useGetConfigs = (domainId: string) =>
  useQuery({
    queryKey: [`configs_${domainId}`],
    queryFn: () => getConfigs(domainId),
    retry: false,
  });

export const useEditConfigs = () => {
  const queryClient = useQueryClient();
  const createToast = useToast();
  const { t } = useTranslation();
  const { mutate: updateConfigs, ...rest } = useMutation<
    IConfigPayload[],
    AxiosError,
    IConfig
  >({
    mutationFn: editConfigs,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [`configs_${variables.domainId}`],
      });
      createToast({
        message: t('toast.configsUpdated'),
        type: 'positive',
      });
    },
    onError: (error) => {
      const messageFromResponse =
        error?.response?.data &&
        typeof error.response.data === 'object' &&
        'message' in error.response.data &&
        typeof error.response.data.message === 'string'
          ? error.response.data.message
          : undefined;
      createToast({
        message: messageFromResponse || error.message,
        type: 'negative',
      });
    },
  });
  return { updateConfigs, ...rest };
};
